import {
  faBookmark,
  faCheck,
  faExclamation,
  faTimes,
} from '@document-crunch/pro-regular-svg-icons'

export const OPTION_GROUP_QUESTIONS = {
  o1: 'Are you okay with how this is treated in the contract?',
  o2: 'What is the risk level for this item?',
  o3: 'What is the risk level for this item?',
}

export const ANSWER_TYPES = {
  Yes: 'option1Count',
  High: 'option1Count',
  'Tier 1': 'option1Count',
  No: 'option2Count',
  Medium: 'option2Count',
  'Tier 2': 'option2Count',
  'Needs Further Review': 'option3Count',
  Low: 'option3Count',
  'Tier 3': 'option3Count',
} as { [key: string]: 'option1Count' | 'option2Count' | 'option3Count' }

export const OPTION_GROUPS = {
  o1: ['Yes', 'No', 'Needs Further Review'],
  o2: ['High', 'Medium', 'Low'],
  o3: ['Tier 1', 'Tier 2', 'Tier 3'],
} as { [key: string]: string[] }

export const FILTERS_OPTION_GROUPS = {
  o1: ['Yes', 'No', 'Review'],
  o2: ['High', 'Medium', 'Low'],
  o3: ['Tier 1', 'Tier 2', 'Tier 3'],
} as { [key: string]: string[] }

const SUCCESS_CLASSES = {
  textColor: 'tw-text-success-600',
  borderColor: 'tw-border-success-500',
  lightColor: 'tw-text-success-50',
  bgColor: 'tw-bg-success-50',
  hoverColor: 'hover:tw-bg-success-200',
}

const DANGER_CLASSES = {
  textColor: 'tw-text-destructive-600',
  borderColor: 'tw-border-destructive-600',
  lightColor: 'tw-text-destructive-100',
  bgColor: 'tw-bg-destructive-50',
  hoverColor: 'hover:tw-bg-destructive-100',
}

const WARNING_CLASSES = {
  textColor: 'tw-text-warning-600',
  borderColor: 'tw-border-warning-600',
  lightColor: 'tw-text-warning-50',
  bgColor: 'tw-bg-warning-50',
  hoverColor: 'hover:tw-bg-warning-100',
}

export const OPTION_GROUP_MAP = {
  o1: {
    Yes: { ...SUCCESS_CLASSES, icon: faCheck },
    No: { ...DANGER_CLASSES, icon: faTimes },
    'Needs Further Review': { ...WARNING_CLASSES, icon: faBookmark },
  },
  o2: {
    High: { ...DANGER_CLASSES, icon: faTimes },
    Medium: { ...WARNING_CLASSES, icon: faExclamation },
    Low: { ...SUCCESS_CLASSES, icon: faCheck },
  },
  o3: {
    'Tier 1': { ...DANGER_CLASSES, icon: faTimes },
    'Tier 2': { ...WARNING_CLASSES, icon: faExclamation },
    'Tier 3': { ...SUCCESS_CLASSES, icon: faCheck },
  },
} as { [key: string]: { [key: string]: string | any } }

export const SUB_QUESTION_OPTIONS = {
  o2: [
    { id: 1, value: 'High' },
    { id: 2, value: 'Medium' },
    { id: 3, value: 'Low' },
  ],
  o1: [
    { id: 1, value: 'Yes' },
    { id: 2, value: 'No' },
    { id: 3, value: 'N/A' },
  ],
} as { [key: string]: { id: number; value: string }[] }

export const DONE_SECTION_TITLE = '**DONE**'

export const GEN_CL_LOADING_COPY = ['Analyzing your document...']
